import { motion } from 'framer-motion';
import { Portfolio } from '../../../../types';

const PortfolioCard = ({
  portfolio,
  isMobile,
  onClick,
  index,
  isInView,
}: {
  portfolio: Portfolio;
  isMobile: boolean;
  onClick: () => void;
  index: number;
  isInView: boolean;
}) => {
  return (
    <motion.button
      className="w-full h-auto rounded-lg md:rounded-2xl lg:rounded-3xl overflow-hidden cursor-pointer"
      onClick={onClick}
      initial={{ opacity: 0, y: 50 }}
      animate={{
        opacity: isInView ? 1 : 0,
        y: isInView ? 0 : 50,
      }}
      exit={{ opacity: 0, y: -20 }}
      transition={{
        duration: 0.6,
        delay: isInView ? index * 0.1 : 0,
        ease: 'easeOut',
      }}
      layout
    >
      <img
        src={isMobile ? portfolio.mobileImageLink : portfolio.image}
        alt={portfolio.alt}
        className="w-full h-auto rounded-lg sm:rounded-xl md:rounded-2xl lg:rounded-3xl transform transition duration-300 hover:scale-[102%]"
      />
    </motion.button>
  );
};

export default PortfolioCard;
